import {
  SET_UPDATE_SCHEDULE_RANGE,
  SET_ERROR,
  SET_LOADING,
  SET_IS_APPOINTMENT_POPUP_SHOWN,
  SET_IS_SUCCESS_SCHEDULE_EDIT,
  RESET_SCHEDULE_RECURRING_INFO,
  UPDATE_SCHEDULE,
} from './CalendarConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const updateSchedule = (from, to) => {
  const action = {
    type: SET_UPDATE_SCHEDULE_RANGE,
    payload: { from, to },
  }
  return action
}

export const setError = (code = '', extra = null) => {
  const action = {
    type: SET_ERROR,
    payload: { UserFriendlyErrorCode: code, extra },
  }
  return action
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setCalendarLoading = (newStatus) => {
  const action = {
    type: SET_LOADING,
    payload: newStatus,
  }
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsAppointmentPopUpInfoVisible = (newState) => {
  const action = {
    type: SET_IS_APPOINTMENT_POPUP_SHOWN,
    payload: newState,
  }
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsSuccessScheduleEdit = (newState, tabId) => {
  const action = {
    type: SET_IS_SUCCESS_SCHEDULE_EDIT,
    payload: newState,
    extraData: { tabId },
  }
  return action
}

export const resetScheduleInfoRecurring = () => {
  const action = {
    type: RESET_SCHEDULE_RECURRING_INFO,
  }
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const updateScheduleView = (payload, tabId) => ({
  type: UPDATE_SCHEDULE,
  payload,
  extraData: { tabId },
})
